import Main from '@/views/administracion/ejecucion/configuracion/Main.vue';
import MainFirmas from '@/views/administracion/ejecucion/configuracion/firmas/Main.vue';
import MainEtiquetas from '@/views/administracion/ejecucion/configuracion/etiquetas/Main.vue';
import MainPlantillas from '@/views/administracion/ejecucion/configuracion/plantillas/Main.vue';

const auth = ['Supervisión:ver'];
const scopes = ['Supervisión:crear', 'Supervisión:editar', 'Supervisión:eliminar'];

const configuracion = [
  {
    path: 'configuracion',
    meta: {
      title: 'Configuración',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'ejecuccionConfiguracionFirmas',
        path: 'firmas',
        meta: {
          title: 'Firmas',
          auth,
          scopes,
        },
        component: MainFirmas,
        children: [],
      },
      {
        name: 'ejecucionConfiguracionPlantillas',
        path: 'plantillas',
        meta: {
          title: 'Plantillas',
          auth,
          scopes,
        },
        component: MainPlantillas,
        children: [],
      },
      {
        name: 'ejecucionConfiguracionEtiquetas',
        path: 'etiquetas',
        meta: {
          title: 'Etiquetas',
          auth,
          scopes,
        },
        component: MainEtiquetas,
        children: [],
      },
    ],
  },
];

export default configuracion;
